module.exports = __webpack_public_path__ + "img/thumbnail_AlpineGoat_f_melanistic.5e046f2a.png";